import { makeStyles } from '@material-ui/core';

export const useCheckboxStyles = makeStyles((theme) => ({
  root: {
    width: '24px',
    height: '24px',
  },
  component: {
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  icon: {
    borderRadius: '4px',
    width: '24px',
    height: '24px',
    backgroundColor: 'transparent',
    border: `1px solid rgba(255, 255, 255,0.15)`,
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '$checked &': {
      backgroundColor: 'transparent',
      border: `1px solid transparent`,
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
  },
  checked: {},
}));
